import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App"; // Main website
import reportWebVitals from "./reportWebVitals";

// ----------------------------------------------------
// 🚨 0. GLOBAL FIX FOR CHUNKLOAD ERROR (MAIN APP ONLY)
// ----------------------------------------------------
function enableChunkFixForMainApp() {
  window.addEventListener("unhandledrejection", (event) => {
    if (event?.reason?.message?.includes("ChunkLoadError")) {
      console.warn("❌ ChunkLoadError detected → reloading main site…");
      window.location.reload(true);
    }
  });

  window.addEventListener("error", (event) => {
    const msg = event?.message || "";
    if (msg.includes("ChunkLoadError") || msg.includes("Loading chunk")) {
      console.warn("❌ Failed to load a JS chunk (main app) → refreshing…");
      window.location.reload(true);
    }
  });
}

// ----------------------------------------------------
// 📦 Regular React imports
// ----------------------------------------------------
 
// Lazy load Landing App
const LandingApp = React.lazy(() => import("./landing")); 

// ----------------------------------------------------
// 🧭 Detect landing routes (NO chunk fix here)
// ----------------------------------------------------
const currentPath = window.location.pathname;

// ✅ FIXED: Perfectly mapped all Main courses & their exact Thank You pages
const isLandingRoute =
  // 1. Data Science Landing & Thank You
  currentPath.startsWith("/datascience-course-bangalore") ||
  currentPath.startsWith("/thankyou") || // Kept as fallback just in case
  currentPath.startsWith("/thank-you") || // 🚨 ADDED: Fixes the 404 after form submit!
  
  // 2. Digital Marketing Landing & Thank You
  currentPath.startsWith("/digital-marketing-course-bangalore") ||
  currentPath.startsWith("/digital-marketing-thankyou") ||
  
  // 3. Makeup/Beauty Landing & Thank You
  currentPath.startsWith("/makeup-course-bangalore") ||
  currentPath.startsWith("/beauty-thankyou") ||
  
  // 4. Other Landing Pages
  currentPath.startsWith("/event-registration"); 

// ----------------------------------------------------
// 🛠 Enable ChunkLoadError Fix ONLY for Main App
// ----------------------------------------------------
if (!isLandingRoute) {
  enableChunkFixForMainApp();
}

// ----------------------------------------------------
// 🚀 Render App / LandingApp
// ----------------------------------------------------
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <React.Suspense fallback={<div>Loading Modules...</div>}>
      {isLandingRoute ? <LandingApp /> : <App />}
    </React.Suspense>
  </React.StrictMode>
);

// ----------------------------------------------------
// 🛑 Disable service worker (prevents stale JS caching)
// ----------------------------------------------------
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (let sw of registrations) {
      sw.unregister();
    }
  });
}

// ----------------------------------------------------
// 📊 Optional performance reporting
// ----------------------------------------------------
reportWebVitals();